// Dashboard Variable

// export const baseUrl = "http://localhost/slraheja/sl-raheja/public/";

// export const baseUrl = "https://slraheja-api.armworldwide.com/";
export const baseUrl = "https://slrhapi.rahejahospital.com/"

// export const baseImage_path = "http://localhost/slraheja/sl-raheja/public";
// export const baseImage_path = "https://slraheja-api.armworldwide.com/";
export const baseImage_path = "https://slrhapi.rahejahospital.com/"
